import DOMPurify from 'dompurify'

// Rich-text policy content is sanitized server-side on save (sanitize-html allowlist), but we
// never trust that at the render sink: this is the last line of defence against stored XSS if
// the server control ever regresses or content arrives via another path. Allowlist mirrors the
// server and the Lexical 0.45 output tag set (headings, marks, lists, blockquote, links,
// tables); inline style/class are dropped (styling comes from CSS) and URL schemes are limited.
const ALLOWED_TAGS = [
  'h1',
  'h2',
  'h3',
  'p',
  'br',
  'span',
  'b',
  'strong',
  'i',
  'em',
  'u',
  's',
  'ul',
  'ol',
  'li',
  'blockquote',
  'a',
  'table',
  'colgroup',
  'col',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
]

export function sanitizePolicyHtml(html: string | null | undefined): string {
  return DOMPurify.sanitize(html || '', {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ['href', 'value', 'span', 'colspan', 'rowspan'],
    ALLOWED_URI_REGEXP: /^(?:https?|mailto):/i,
  })
}
